import { render, staticRenderFns } from "./WorksComponent.vue?vue&type=template&id=179bb22a"
import script from "./WorksComponent.vue?vue&type=script&lang=js"
export * from "./WorksComponent.vue?vue&type=script&lang=js"
import style0 from "./WorksComponent.vue?vue&type=style&index=0&id=179bb22a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports